// extracted by mini-css-extract-plugin
export default {"wrapper":"kypIF","image":"gE2GN","svg":"IHVcf"};